import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { register } from '~/core/repository'
import { $parentCategoryMoviesFormatted } from '~/entities/movies/model'
import { model as movieSubcategoriesModel } from '~/entities/movies/subcategories'
import { genPagesLogic } from '~/shared/effector'
import { nay, T } from '~/shared/helpers'
import '~/shared/ui/translations/general-translations'

const DEFAULT_ROWS_COUNT = 9

export const initSubCategoriesPage = createEvent<{
  categoryId: number
}>()

export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

sample({
  clock: initSubCategoriesPage,
  filter: not(api.vods.initVodsSubCategoryFx.pending),
  fn: ({ categoryId }) => ({ categoryId, page: 0, count: DEFAULT_ROWS_COUNT }),
  target: api.vods.initVodsSubCategoryFx,
})

/********** Skeleton logics starts ***********/
sample({
  clock: initSubCategoriesPage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.vods.initVodsSubCategoryFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

const loadMoreSubCategories = genPagesLogic(
  api.vods.$pageInfoSubCategoriesWithVods,
  api.vods.loadSubCategoriesWithVodsFx
)

// clear paginatable stores
api.vods.$subCategoriesWithVods.reset([initSubCategoriesPage])

register(
  movieSubcategoriesModel.$subCategoriesWithVodsFormatted,
  '$subCategoriesWithVods'
)
register(loadMoreSubCategories, 'loadMoreSubCategories')
register($parentCategoryMoviesFormatted, '$parentCategoryMoviesFormatted')
